var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"data":_vm.data,"extra-info":_vm.extraInfo,"base-info":_vm.baseInfo,"status-module":"server","resource":"servers","on-manager":_vm.onManager}})
}
var staticRenderFns = []

export { render, staticRenderFns }